import type { Dayjs } from "dayjs";

export type Filter = {
  type:
    | "select"
    | "text"
    | "date"
    | "custom_select"
    | "multi_select"
    | "date_range_preset";
  label: string;
  options?: any[];
  placeholder?: string;
  onSearch?: (value: string) => void;
  /** For date_range_preset: formik keys for date_range, startDate, endDate so applied values stay flat. */
  childKeys?: [string, string, string];
  /** For type "date": upper bound passed through to CustomDatePicker. */
  maxDate?: Dayjs;
  /** For type "date": lower bound passed through to CustomDatePicker. */
  minDate?: Dayjs;
};

export type FilterRecord = Record<string, Filter>;

export const INVALID_DATE_MESSAGE = "Enter a valid date";
